import React from "react";
import Text from "@amzn/meridian/text";
import { Space } from "../space/Space";
import _ from "lodash";
import { InputWrapper } from "./InputWrapper";
import { Field } from "formik";
import { IForm } from "./definitions";

export const getFormInput = formConfig => {
    return Object.entries(formConfig).map(([sectionKey, sectionValue]: [string, any]) => {
        return (
            <React.Fragment>
                <Text key={_.uniqueId("section_space")} type={"h300"}>
                    {sectionValue.label}
                </Text>
                <Space key={_.uniqueId("section_space")} size={"xs"} />
                {sectionValue.inputs.map(inputConfig => {
                    return (
                        <Field name={inputConfig.fieldName}>
                            {fieldProps => {
                                return (
                                    <InputWrapper
                                        fieldProps={fieldProps}
                                        key={`${sectionKey}.${inputConfig.inputKey}_inputWrapper`}
                                        {...inputConfig}
                                    />
                                );
                            }}
                        </Field>
                    );
                })}

                <Space key={_.uniqueId("section_space")} size={"s"} />
            </React.Fragment>
        );
    });
};

export const getSingleInputWithField = inputConfig => {
    return (
        <React.Fragment>
            <Field name={inputConfig.fieldName}>
                {(fieldProps: any) => {
                    return <InputWrapper fieldProps={fieldProps} {...inputConfig} />;
                }}
            </Field>
        </React.Fragment>
    );
};

export const generateFormSteps = (props: Partial<IForm>): IForm => {
    return {
        label: props.label,
        name: _.snakeCase(props.label),
        progressState: props.progressState || "future",
        progressAlert: props.progressAlert || "none",
        validationSchema: props.validationSchema || null,
        onSubmit: props.onSubmit || null,
        formInputs: props.formInputs,
    };
};

export interface PropertyBasicInformation {
    propertyType: string;
    propertySubType: string;
    generalLedgerNumber: string;
    grossBuildingArea: string;
    grossLeasableArea: string;
    siteArea: string;
    siteUsableArea: string;
    yearBuilt: string;
}

export const propertyDetailKeys = {
    propertyId: ["propertyNumber", "siteCode"],
    address: ["address"],
    basicInformation: [
        "propertyType",
        "propertySubType",
        "generalLedgerNumber",
        "grossBuildingArea",
        "grossBuildingAreaUnit",
        "grossLeasableArea",
        "grossLeasableAreaUnit",
        "siteArea",
        "siteAreaUnit",
        "siteUsableArea",
        "siteUsableAreaUnit",
        "yearBuilt",
        "effectiveYear",
        "age",
        "climate",
        "region",
    ],
    statusAndOwnership: [
        "status",
        "ownershipStatus",
        "entityName",
        "entityCode",
        "secDivision",
        "dateOpened",
        "dateClosed",
    ],
    otherInformation: ["contacts", "assignedTo", "propertyOtherDescription", "landlord"],
    financialInformation: ["saleDate", "currency", "leaseRate", "salePrice", "constructionCost"],
    siteImprovements: ["improvements", "otherImprovements", "siteImprovementDetails"],
    spaceDetails: ["spaceDetails"],
    featureDetails: ["featureDetails"],
};

export const parcelDataExtractKeys = {
    parcelNumber: ["parcelNumber"],
    siteCode: ["siteCode"],
    address: ["address"],
    basicInformation: [
        "parcelType",
        "parcelSubType",
        "grossBuildingArea",
        "grossBuildingAreaUnit",
        "grossLeasableArea",
        "grossLeasableAreaUnit",
        "siteArea",
        "siteAreaUnit",
        "siteUsableArea",
        "siteUsableAreaUnit",
        "yearBuilt",
    ],
    statusAndOwnership: [
        "status",
        "ownershipStatus",
        "entityName",
        "entityCode",
        "secDivision",
        "dateOpened",
        "dateClosed",
    ],
    otherInformation: ["contacts", "assignedTo", "propertyOtherDescription"],
    financialInformation: ["saleDate", "currency", "leaseRate", "salePrice", "constructionCost"],
};
